import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import fetch from '@costar/costar-fetch';
import urljoin from 'url-join';

function submitFeedback(_x) {
  return _submitFeedback.apply(this, arguments);
}
function _submitFeedback() {
  _submitFeedback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    var apiBasePath, request, url;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiBasePath = params.apiBasePath, request = params.request;
          url = urljoin(apiBasePath, '/shared-api/share-feedback');
          _context.prev = 2;
          _context.next = 5;
          return fetch.put(url, {
            body: JSON.stringify(request),
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 5:
          _context.next = 10;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](2);
          console.error({
            msg: 'Submit share feedback failed',
            error: _context.t0
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 7]]);
  }));
  return _submitFeedback.apply(this, arguments);
}

export { submitFeedback as default };
//# sourceMappingURL=submit-feedback.esm.js.map
